import React from 'react';
import {MasterLayout} from 'components/layouts';
import {Contact} from 'components/contact'
import title from 'constants/TitlePages.js';

class ContactPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.ContactPage;
  }

  render() {
    return (
      <MasterLayout>
        <Contact/>
      </MasterLayout>
    );
  }
}

export default ContactPage;


// WEBPACK FOOTER //
// ./pages/contact/ContactPage.jsx